export default __webpack_public_path__ + "static/media/Hangman2.ba1e1a42.svg";